import React from "react";
import { Card } from "react-bootstrap";
import { tabHeadingDictionary as tabKeywords } from "@core/global/global-country-dictionary";
import GlobalAnalytics from "../../../../../shared/analytics-components/globalAnalytics";
import AnalyticsImg from "@assets/images/analytics.svg";
import UpgradeIcon from "@assets/images/Solid_Status_Lightning-alt.svg";

const Analytics = (props) => {
  return (
    <div>
      <div className={props.currentTab === tabKeywords.analytics ? "tab-pane fade show active" : "tab-pane fade"} id="nav-summary" role="tabpanel" aria-labelledby="nav-summary-tab">
        <div className="trademo-table-container pt-3">
          {!!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.is_analytics_tab === false ? (
            <Card className="upgrade-card">
              <Card.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-auto">
                      <div>
                        <img src={UpgradeIcon} alt="..." className="img-fluid" />
                      </div>
                    </div>
                    <div className="col">
                      <p>Access quick Analytics on the searched shipments</p>
                      <p>Upgrade to higher plan to use this feature</p>
                      <div className="d-block my-3">
                        <button type="button" className="btn btn-success tw-bg-secondary-green" onClick={(e) => props.upgradeNow(e)}>
                          Upgrade
                        </button>
                      </div>
                      <div className="d-block">
                        <img src={AnalyticsImg} alt="..." className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <>
              {!!props.analyticsData && props.analyticsData.length !== 0 ? (
                <GlobalAnalytics
                  trade_direction={props?.defaultData?.manyCountryType || ""}
                  country={props?.defaultData?.countryShortHand?.toLowerCase() || props?.defaultData?.countryCode?.toLowerCase() || ""}
                  isDownloadPDFExport={props.defaultData.exportPDFInAnalytics}
                  isLoader={props.isActiveLoader || props.analyticsLoader}
                  isDownloadPDFExportFrontend={!!props.defaultData && !!props.defaultData.exportPDFInAnalyticsFrontend && props.defaultData.exportPDFInAnalyticsFrontend === true ? true : false}
                  dropdownOptions={props.analyticDropdownOptions}
                  mainLabelOptions={props.mainLabelOptions}
                  analyticsType={props.analyticsType}
                  analyticsHeaderItems={props.defaultData.analyticsHeaderItems}
                  analyticsItems={props.defaultData.analyticsFieldsMapping}
                  analyticsViewAllData={props.fetchSummaryViewAllData}
                  fetchSummaryTrendsData={props.fetchSummaryTrendsData}
                  analyticsDataSource={(e) => props.getAnalyticsData("search", e)}
                  graphData={props.analyticsData}
                  downloadAnalyticsPDF={true}
                  downloadPDF={(e) => props.downloadAnalyticsPDF(e)}
                  from={props.defaultData.analyticsCountryID}
                  entireRequestObject={props.finalReqObj}
                  filterList={props.filterMapList}
                  appliedState={props.appliedStateFilterObject}
                  showTwoLevel={props.showTwoLevel}
                  pathname={window.location.pathname}
                  analyticsCountryID={props.defaultData.analyticsCountryID}
                  currentUserPlan={props.currentUserPlan}
                  includeFilter={props.includeFilter}
                  excludeFilter={props.excludeFilter}
                  currentTab={props.currentTab}
                  gridCacheKey={`${props?.defaultData?.country_small}_${props?.defaultData?.countryType}`}
                />
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Analytics);
